import type { ReactNode } from 'react'
import clsx from 'clsx'
import './cf-section-shell.css'

export type PaddingToken =
  | 'none'
  | 'xs'
  | 'sm'
  | 'md'
  | 'lg'
  | 'xl'
  | null
  | undefined

type ThemeToken =
  | 'light'
  | 'dark'
  | 'brand'
  | 'muted'
  | 'surface'
  | null
  | undefined

export type CfSectionShellFields = {
  id?: string
  paddingTop?: PaddingToken
  paddingBottom?: PaddingToken
  theme?: ThemeToken
  fullWidth?: boolean
  mobileNoTopPadding?: boolean
  showBottomBorder?: boolean
}
// Removed export
type CfSectionShellProps = {
  children: ReactNode
} & CfSectionShellFields

const padTopClass = (token: PaddingToken) => {
  switch (token) {
    case 'none':
      return 'pt-0'
    case 'xs':
      return 'pt-xs'
    case 'sm':
      return 'pt-sm'
    case 'md':
      return 'pt-md'
    case 'lg':
      return 'pt-lg'
    case 'xl':
      return 'pt-xl'
    default:
      return 'pt-lg'
  }
}

const padBottomClass = (token: PaddingToken) => {
  switch (token) {
    case 'none':
      return 'pb-0'
    case 'xs':
      return 'pb-xs'
    case 'sm':
      return 'pb-sm'
    case 'md':
      return 'pb-md'
    case 'lg':
      return 'pb-lg'
    case 'xl':
      return 'pb-xl'
    default:
      return 'pb-lg'
  }
}

const themeClass = (theme: ThemeToken) => {
  switch (theme) {
    case 'dark':
      return 'bg-zinc-950 text-white'
    case 'brand':
      return 'bg-fuchsia-600 text-white'
    case 'muted':
      return 'bg-zinc-50'
    case 'surface':
      return 'bg-white shadow-sm'
    case 'light':
    default:
      return 'bg-white'
  }
}

export default function CfSectionShell({
  id,
  paddingTop = 'lg',
  paddingBottom = 'lg',
  theme = 'light',
  fullWidth = false,
  mobileNoTopPadding = false,
  showBottomBorder = false,
  children,
}: CfSectionShellProps) {
  const outerTheme = themeClass(theme)

  return (
    <section
      id={id || undefined}
      className={clsx(
        `cf-section-shell`,
        showBottomBorder && 'cf-section-shell--bordered',
        outerTheme,
        fullWidth && 'full-width',
      )}
    >
      <div
        className={clsx(
          padTopClass(paddingTop),
          padBottomClass(paddingBottom),
          mobileNoTopPadding && 'mobile-pt-0',
        )}
      >
        <div
          className={clsx('px-4 sm:px-6', fullWidth ? '' : 'mx-auto max-w-7xl')}
        >
          {children}
        </div>
      </div>
    </section>
  )
}
